import { Component, OnInit, EventEmitter, ViewChild, Output, OnChanges, Input, ViewChildren, QueryList, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { PhBhpFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-filter/ph-bhp-filter.component';
import { SopDetail } from 'ph-bhp-feature-packages/ph-bhp-feature-package-elearning/lib/Models';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageEvaluationFilterService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-feature-package-evaluationfilter.service';
import { TranslationKeys } from 'ph-bhp-localization';
import { PhBhpPdfComplianceMultiFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-pdf-compliance-multi-filter/ph-bhp-pdf-compliance-multi-filter.component';
import { PhBhpBarChartComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-bar-chart/ph-bhp-bar-chart.component';
import { FiltersService } from 'src/app/services/filters.service';
import { PhBhpPdfComplianceMultiFilterObserveComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-pdf-compliance-multi-filter-observe/ph-bhp-pdf-compliance-multi-filter-observe.component';
import cloneDeep from 'lodash/cloneDeep';
import { PhBhpObserveChartExportComponent } from '../ph-bhp-observe-chart-export/ph-bhp-observe-chart-export.component';
@Component({
  selector: 'lib-ph-bhp-observe-overall-compliance',
  templateUrl: './ph-bhp-observe-overall-compliance.component.html',
  styleUrls: ['./ph-bhp-observe-overall-compliance.component.css']
})
export class PhBhpObserveOverallComplianceComponent implements OnInit, OnChanges, OnDestroy {
  private static readonly INITIAL_FIELDS = [
    { 'field': 'name', 'title': 'CONFIGURE.DESCRIPTION' }
  ];
  langSubscription: Subscription;
  userSubscription: Subscription;
  institutionSubscription: Subscription;
  compareCard;
  tempFilter;
  showCompareCard;
  singleCard;
  data;
  filterDetails = [];
  isDesktop = true;
  isAdjustableHeight = true;
  @ViewChild('compliance', { static: true }) compliance: PhBhpPdfComplianceMultiFilterObserveComponent;
  @ViewChildren(PhBhpFilterComponent) filters: QueryList<PhBhpFilterComponent>;
  @ViewChildren(PhBhpBarChartComponent) charts: QueryList<PhBhpBarChartComponent>;
  @ViewChild('exportTag', { static: true }) exportTag: PhBhpObserveChartExportComponent;
  initFlag = true;
  sopiDs: Array<any> = [];
  isSavedFromEvaluation: boolean;
  noDataFound: boolean = false;
  percentageLegend = "{0}%";
  complianceType;
  labels;
  pageInfo = {
    ofLabel: 'GENERAL.OF',
    items: 'GENERAL.ITEMS',
    itemsPerPageLabel: 'GENERAL.ITEMS_PAGE'
  };

  isCallFor;
  sopDetail: SopDetail[];
  pageTitle = 'DASHBOARD.OVERALL_COMPLIANCE';
  userID: number;
  roleId: number;
  appName = 'Observe';
  translationKeys: typeof TranslationKeys = TranslationKeys;
  filterIndices: number[] = [0];
  public clickImageBtn = false;
  public clickExcelBtn = false;
  public clickPdfBtn = false;
  evaluationLoaded: boolean = false;
  isBenchmark: boolean = false;
  isEvaluationTable: boolean = true;

  multiSelectText: string = '';
  results: any = [];
  isUserFilterSetted: boolean = false;
  userHasFilter: boolean = false;
  userFilters: any;
  sopFilters: any[] = [];

  filterTitles: string[] = [];
  benchmarkTitles: string[] = [];
  textLegend: string;
  // dataMoments = ["bef.pat", "bef.asept", "aft.b.f", "aft.asept", "aft.p.sur"]

  constructor(
    public appConfig: AppConfig,
    private router: Router,
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    private layoutService: PHBHPLayoutPackageService
  ) {

  }

  ngOnInit(): void {
    this.userID = this.appConfig.userData.userId;
    this.roleId = this.appConfig.userData.roleName.roleId;
    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      setTimeout(() => {
        for (let i = 0; i < this.charts.length; i++) {
          let chart = this.charts.get(i);
          chart.chartOptions.valueAxis.title.text = this.textLegend;
        }

        this.pageTitle = this.layoutService.translateText('DASHBOARD.OVERALL_COMPLIANCE');
        this.compliance.complianceTitle = this.layoutService.translateText('DASHBOARD.OVERALL_COMPLIANCE');

        //Generate again labels for charts and tables
        this.evaluate(true);
        
        this.layoutService.showLoader = false;
      }, 1000);
    });

    this.pageTitle = this.layoutService.translateText('DASHBOARD.OVERALL_COMPLIANCE');
    this.compliance.complianceTitle = this.layoutService.translateText('DASHBOARD.OVERALL_COMPLIANCE');
    this.ngOnChanges();
  }

  ngOnChanges() {
    this.layoutService.showLoader = true;
    this.userHasFilter = false;
    if (!this.isUserFilterSetted) {
      this.evaluationService.getUserHasObserveEvaluationFilter(this.appConfig.userData.userId, 'overallcompliance').subscribe((userHasFilter) => {
        this.isUserFilterSetted = true;
        if (userHasFilter) {
          this.userHasFilter = true;
          this.userFilters = JSON.parse(userHasFilter.filterList);
          this.userFilters = this.userFilters.Filter;
          setTimeout(() => { this.initComponent(); });
        } else {
          this.userFilters = [];
          this.noDataFound = true;
          this.filters.get(0).showFilter(true);
          this.compliance.resultsLoader.next([{}]);
        }
      }, (error) => { }, () => { this.layoutService.showLoader = false; });
    } else {
      setTimeout(() => { this.initComponent(); });
    }
  }

  ngOnDestroy() {
    if (this.langSubscription)
      this.langSubscription.unsubscribe();
    if (this.userSubscription)
      this.userSubscription.unsubscribe();
    if (this.institutionSubscription)
      this.institutionSubscription.unsubscribe();
  }

  initComponent() {
    if (this.userFilters.length > 0) {
      this.userFilters.forEach((filter, idx) => {
        if (!filter.filterName || filter.filterName.trim() === "") {
          filter.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (idx + 1);
        }
      });
      this.filterIndices = this.userFilters.map((_, index) => index);
      this.showCompareCard = this.filterIndices.length > 1;
    }

    if (this.appConfig.userData) {
      for (let i = 0; i < this.charts.length; i++) {
        let chart = this.charts.get(i);
        chart.chartOptions.valueAxis.labels = {
          format: this.percentageLegend
        };
        chart.chartOptions.valueAxis.title = {
          text: this.layoutService.translateText('EVALUATION.PERCENT_COMPLIANCE'),
          font: "9px OpenSans-Regular"
        };
      }

      this.pageTitle = this.layoutService.translateText('DASHBOARD.OVERALL_COMPLIANCE');
      this.compliance.complianceTitle = this.layoutService.translateText('DASHBOARD.OVERALL_COMPLIANCE');
      this.compliance.showFilter = true;
      this.compliance.complianceTitle = this.pageTitle;
      this.compliance.roleId = this.roleId;
      this.compliance.fillWith = 'N/A';
      this.loadFiltersInfo();
      if (this.userFilters && this.userFilters.length >= 2 && this.isDesktop) {
        this.showCompareCard = this.filterIndices.length > 1;
        this.compliance.showCompareCard = this.showCompareCard;
        this.tempFilter = this.userFilters;
      }

      this.evaluate(true, true);
    }
  }

  evaluate(getResults, initialize?) {
    this.printConfig();
    this.data = {
      filter: [],
      isBenchMark: true,
      roleId: this.roleId,
    };

    if (initialize) {
      this.data.filter = this.userFilters;
    } else {
      this.filters.forEach((filter) => {
        let filterData: any = {
          startDate: filter.range.start,
          endDate: filter.range.end,
          instutionIDs: "",
          departmentID: "",
          wardID: "",
          professionalCategoryID: "",
          subprofessionalCategoryID: "",
          countryID: 0
        };

        if (this.roleId == 1 && filter.setCountry != 0) {
          filterData.countryID = filter.setCountry.countryID
        }

        filterData = filter.assignData(filterData);
        this.data.filter.push(filterData);
        if (filterData.multiSelectName) {
          this.multiSelectText = filterData.multiSelectName;
        }
      });
    }

    this.compliance.setFilters(this.filters.toArray());
    this.userHasFilter = true;
    if (getResults == true) {
      this.getOverallcomplianceFilterDetails(this.userID, this.data);
    } else if (getResults == false) {
      this.saveFiveMomentsDetails(this.userID, this.data)
    }
  }

  async loadFiltersInfo() {
    setTimeout(() => {
      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if (this.roleId == 1) {
          filterComponent.setSAFilter(filter, true);
        } else {
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID, '', '', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          if (filterComponent.wardListLoaded && filterComponent.wardListLoaded.length > 0) {
            filterComponent.onWardChange(filterComponent.wardListLoaded.find(ward => ward.wardID == filter.wardID));
          }

          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.subprofessionalCategoryID, true);
          if (filter.multiselect) {
            filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
          }
        }
      });
    }, 1000);
  }

  resetExportAs(value: 'image' | 'excel' | 'pdf') {
    switch (value) {
      case 'image':
        this.clickImageBtn = false;
        break;
      case 'excel':
        this.clickExcelBtn = false;
        break;
      case 'pdf':
        this.clickPdfBtn = false;
        break;
    }
  }

  emitData(valve) {
    if (valve.value) {
      this.appConfig.filterDetails = valve.value;
      this.appConfig.dropdownChanged = "changed";
    } else {
      this.appConfig.filterDetails = [];
    }
    switch (valve.key) {
      case 'back': this.router.navigate(['evaluation/observeObservation/statistical']); break; // this._location.back();
      case 'overallCompliance': this.router.navigate(['evaluation/observe/overallCompliance']); break;
      case '5Moments': this.router.navigate(['evaluation/observe/fivemoments']); break;
      case 'individualData': this.router.navigate(['evaluation/observe/individualOverview']); break;
      case 'beforeAsepticProcedures': this.router.navigate(['evaluation/observe/StatisticsBeforeAsepticProcedures']); break;
      case 'comments': this.router.navigate(['evaluation/observe/comments']); break;
      case 'quota': this.router.navigate(['evaluation/observe/quota']); break;
      default: this.router.navigate(['evaluation/observeObservation/statistical']); break;
    }
  }

  filterCompare() {
    this.compareCard = false;

    if (this.filterIndices.length < 6) {
      this.filterIndices.push(this.filterIndices.length);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    this.layoutService.showLoader = true;
    setTimeout(() => {
      var filters = this.filters.toArray();
      filters[filters.length - 1].setInfoFromFilter(cloneDeep(filters[filters.length - 2]));
      this.layoutService.showLoader = false;
    }, 500);

    if (!this.userHasFilter) {
      this.filters.get(0).showFilter(true);
      return;
    }
  }


  printConfig() {
    if (this.sopiDs.length == 0) {
      this.compliance.SOPList = this.sopiDs;
      this.compliance.SOPName = undefined;
    } else {
      this.compliance.SOPList = undefined;
      this.compliance.SOPName = this.layoutService.translateText("EVALUATION.All.SOP");
    }
  }

  showFilter(cardType) {
    const showFilter = cardType;
    if (showFilter == 'singleCard') {
      this.singleCard = !this.singleCard;
      this.compareCard = false;
    }
    if (showFilter == 'compareCard') {
      this.compareCard = !this.compareCard
      this.singleCard = false;
    }
  }

  cancelFilter() {
    this.singleCard = false;
    this.compareCard = false;
  }

  saveFiveMomentsDetails(userID, data) {
    this.isCallFor = "empty";
    this.complianceType = "overallcompliance";
    this.isSavedFromEvaluation = false;
    this.layoutService.showLoader = true;
    var selectedSeries = JSON.stringify(Array.from(this.selectedSeries))
    this.data.selectedSeries = selectedSeries;
    this.evaluationService.SaveSummarisedDetail(userID, this.isSavedFromEvaluation, this.complianceType, data).subscribe(res => {
      this.layoutService.showLoader = false;
      this.layoutService.showSuccess(this.layoutService.translateText("EVALUATION.SUCCESSFULLY_SAVED_SUMMARISED_REPORT"));
    });
  }

  getOverallcomplianceFilterDetails(userID, data) {
    this.complianceType = "overallcompliance";
    this.isCallFor = "overallcompliance";
    this.isSavedFromEvaluation = true;
    this.layoutService.showLoader = true;
    this.evaluationService.getOverallComplianceDetailsMulti(userID, this.isSavedFromEvaluation, this.isCallFor, data).subscribe((res: any) => {
      this.buildChart(res);
    })
  }

  createFilterData(userID) {
    const defaultFilterData = {
      startDate: new Date(),
      endDate: new Date(),
      instutionIDs: "",
      departmentID: "",
      wardID: "",
      professionalCategoryID: "",
      subprofessionalCategoryID: "",
      countryID: 0
    };

    const filters = this.filters && this.filters.length > 0 ? this.filters.map(filter => {
      let filterData = { ...defaultFilterData, startDate: filter.range.start, endDate: filter.range.end };
      if (this.roleId === 1 && filter.setCountry !== 0) {
        filterData.countryID = filter.setCountry.countryID;
      }
      return filter.assignData(filterData);
    }) : [defaultFilterData];

    return {
      filter: filters,
      countryID: 0,
      isBenchMark: true,
      userId: userID,
      isSavedFromEvaluation: true,
      roleId: this.roleId
    };
  }


  ngAfterViewChecked() {
    if (this.tempFilter) {
      var tempFilter = this.tempFilter;
      this.tempFilter = undefined;

      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if (this.roleId == 1) {
          filterComponent.setSAFilter(filter, true);
        } else {
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID, '', '', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.subprofessionalCategoryID, true);
          if (filter.multiselect) {
            filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
          }
        }
      });
    }
  }

  buildChart(res) {
    this.evaluationLoaded = false;
    var colors = [];
    if (!this.shouldHideBenchmarkDataByResponse(res) || this.shouldHideBenchmarkData()) {
      colors = [
        "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"
      ];
    } else {
      colors = [
        "#001689", "url(#benchmark1)", "#40C4FF", "url(#benchmark2)", "#9744FF", "url(#benchmark3)", "#BF44B9", "url(#benchmark4)", "#E57373", "url(#benchmark5)", "#FFB300", "url(#benchmark6)"
      ];
    }

    res = this.adjustResponseForEnvironment(res);
    res = this.filterBenchmarkDataIfWardIsSelected(res);

    let chart: PhBhpBarChartComponent;
    this.results = [];
    const categoryTitle: string = 'DASHBOARD.TOTAL_PERCENT_COMPLIANCE';
    res.forEach(result => {
      if (result.overallComplianceList.length > 0) {
        let id = result.filterType || 'single';
        if (this.results.findIndex(r => r.id === id) === -1) {
          this.results.push({
            id,
            overallComplianceList: [],
            gridData: [],
            fields: [...PhBhpObserveOverallComplianceComponent.INITIAL_FIELDS],
            benchmarkFields: [...PhBhpObserveOverallComplianceComponent.INITIAL_FIELDS],
            noDataFound: true
          });
        }
      }
    });

    this.compliance.resultsLoader.next(Object.assign([], this.results));
    // The timeout is necessary to give the chart QueryList time to load the component
    setTimeout(() => {
      let filterCount: number = 0;
      let benchmarkCount: number = 0;
      let filterTableCount: number = 0;
      let benchmarkTableCount: number = 0;
      res.forEach((overallComplianceArray: any, index) => {
        let chartId = overallComplianceArray.filterType || 'single';
        overallComplianceArray.filterType = chartId;
        let chartIndex = this.results.findIndex(r => r.id === chartId);
        chart = this.charts.get(chartIndex);
        let data = JSON.parse(JSON.stringify(chart.chartOptions));

        // Initialize only first iteration of the chart
        if (!data.setId) {
          data.nextIndex = 0;
          data.categoryAxis.categories = [];
          data.categoryAxis.categoryOffset = [];
          data.series = [];
          data.seriesIdentifier = [];
        }

        data.series[data.nextIndex] = { data: [], name: [], dataOffset: [], serieIndex: index };
        data.series[data.nextIndex].color = colors[index];
        data.seriesIdentifier[data.nextIndex] = [];
        chart.chartId = chartId;

        if (overallComplianceArray.isBenchmark === false) {
          if (overallComplianceArray.overallComplianceList.length === 1 && overallComplianceArray.overallComplianceList[0].list.length === 0 && chart.noDataFound) {
            this.noDataFound = true;
            chart.noDataFound = true;
          } else {
            this.results[chartIndex].noDataFound = false;
            this.noDataFound = false;
            chart.noDataFound = false;
          }
        } else {
          if (overallComplianceArray.overallComplianceList.length === 2 && overallComplianceArray.overallComplianceList[0].list.length === 0 && chart.noDataFound) {
            this.noDataFound = true;
            chart.noDataFound = true;
          } else {
            this.results[chartIndex].noDataFound = false;
            this.noDataFound = false;
            chart.noDataFound = false;
          }
        }

        overallComplianceArray.overallComplianceList.forEach((overallCompliance) => {
          let overallComplianceItem = overallCompliance;
          data.series[data.nextIndex].dataSetId = overallComplianceItem.id;
          overallComplianceItem.list.forEach((item) => {
            data.series[data.nextIndex].data.push(item.compliance >= 0 ? item.compliance : "NODATA");
            let title = this.layoutService.translateText(categoryTitle);
            if (overallComplianceItem.id >= 0 && overallComplianceItem.name) {
              title += " - " + this.layoutService.translateText(overallComplianceItem.name);
            }
            title = title ? title : item.title;
            data.series[data.nextIndex].dataOffset.push({ id: title, setId: overallComplianceItem.id, value: item.compliance >= 0 ? item.compliance : "NODATA" });
            data.seriesIdentifier[data.nextIndex].push({ id: title, setId: overallComplianceItem.id });
            if (!data.categoryAxis.categories.includes(title)) {
              data.categoryAxis.categories.push(title);
              data.categoryAxis.categoryOffset.push({ id: title, setId: overallCompliance.id });
            }
          });
        });

        let maxLength = data.categoryAxis.categoryOffset.length
        const combinedData = data.series.map(() => new Array(maxLength).fill(null));

        data.series.forEach((item, serieIndex) => {
          item.dataOffset.forEach((value, index) => {
            let indexOffset = data.categoryAxis.categoryOffset.findIndex(offset => offset.id === value.id && offset.setId === value.setId);
            combinedData[serieIndex][indexOffset] = value.value;
          });
        });

        for (let i = 0; i < combinedData.length; i++) {
          data.series[i].data = combinedData[i];
        }

        if (overallComplianceArray.isBenchmark) {
          if (this.shouldHideBenchmarkData()) {
            return;
          }
          benchmarkCount++;
          const benchmarkName = `${this.data.filter && this.data.filter[benchmarkCount-1] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.filter[benchmarkCount-1].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkCount)}`
          data.series[data.nextIndex].name = [benchmarkName];
          data.series[data.nextIndex].filterName = [benchmarkName];
          data.series[data.nextIndex].filterNum = benchmarkCount;
        } else {
          filterCount++;
          data.series[data.nextIndex].name = [`${this.data.filter && this.data.filter[filterCount - 1] ? this.data.filter[filterCount - 1].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (filterCount)}`];
          data.series[data.nextIndex].filterName = [`${this.data.filter && this.data.filter[filterCount - 1] ? this.data.filter[filterCount - 1].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (filterCount)}`];
          data.series[data.nextIndex].filterNum = filterCount
        }

        data.categoryAxis.rotation = 0;
        data.categoryAxis.maxDivisions = 12;
        data.setId = chartId;
        data.nextIndex++;
        chart.chartOptions = data;
        chart.chartDatamani();

        let gridData: any[] = this.results[chartIndex].gridData;
        let fields = this.results[chartIndex].fields;
        let benchmarkFields = this.results[chartIndex].benchmarkFields;
        gridData = Object.assign([], gridData);
        if (overallComplianceArray && !overallComplianceArray.isBenchmark) {
          overallComplianceArray.overallComplianceList.forEach((element) => {
            let res2 = element.list;
            let multiName = '';
            let elementId = '';
            if (overallComplianceArray.filterType && overallComplianceArray.filterType != 'single') {
              multiName = element.name;
              elementId = element.id;
              if (element.list.length == 0 && element.noData == true) {
                multiName = 'EVALUATION.NO_DATA'
                elementId = 'nodata';
              }
              fields.push(
                { 'field': `column_filter_${filterTableCount + 1}_${elementId}`, 'title': multiName, 'group': `${this.data.filter && this.data.filter[filterTableCount] ? this.data.filter[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}` },
              );

              res2.forEach((item, i) => {
                if (gridData.length == 0) {
                  var complianceRate = { name: this.layoutService.translateText('DASHBOARD.TOTAL_PERCENT_COMPLIANCE') }
                  var opportunities = { name: this.layoutService.translateText('DASHBOARD.OPPORTUNITIES') }
                  var handrubs = { name: this.layoutService.translateText('DASHBOARD.NUMBER_HANDRUB') }
                  var handwashes = { name: this.layoutService.translateText('DASHBOARD.NUMBER_HANDWASHING') }
                  var departments = { name: this.layoutService.translateText('DASHBOARD.NUMBER_DEPARTMENTS') }
                  var wards = { name: this.layoutService.translateText('DASHBOARD.NUMBER_WARDS') }
                  var countries = { name: this.layoutService.translateText('DASHBOARD.NUMBER_COUNTRIES') }
                  var institutions = { name: this.layoutService.translateText('DASHBOARD.NUMBER_INSTITUTIONS') }

                  complianceRate[`column_filter_${filterTableCount + 1}_${elementId}`] = item.compliance == -1 ? "N/A" : item.compliance;
                  opportunities[`column_filter_${filterTableCount + 1}_${elementId}`] = item.opportunities == -1 ? 0 : item.opportunities;
                  handrubs[`column_filter_${filterTableCount + 1}_${elementId}`] = item.handRubs == -1 ? 0 : item.handRubs;
                  handwashes[`column_filter_${filterTableCount + 1}_${elementId}`] = item.handWashes == -1 ? "N/A" : item.handWashes;
                  departments[`column_filter_${filterTableCount + 1}_${elementId}`] = item.departments == -1 ? 0 : item.departments;
                  wards[`column_filter_${filterTableCount + 1}_${elementId}`] = item.wards == -1 ? 0 : item.wards;
                  countries[`column_filter_${filterTableCount + 1}_${elementId}`] = item.countries == -1 ? 0 : item.countries;
                  institutions[`column_filter_${filterTableCount + 1}_${elementId}`] = item.institutions == -1 ? 0 : item.institutions;

                  gridData.push(complianceRate, opportunities, handrubs, handwashes, departments, wards, countries, institutions);
                } else {
                  gridData[0][`column_filter_${filterTableCount + 1}_${elementId}`] = item.compliance == -1 ? "N/A" : item.compliance;
                  gridData[1][`column_filter_${filterTableCount + 1}_${elementId}`] = item.opportunities == -1 ? 0 : item.opportunities;
                  gridData[2][`column_filter_${filterTableCount + 1}_${elementId}`] = item.handRubs == -1 ? 0 : item.handRubs;
                  gridData[3][`column_filter_${filterTableCount + 1}_${elementId}`] = item.handWashes == -1 ? "N/A" : item.handWashes;
                  gridData[4][`column_filter_${filterTableCount + 1}_${elementId}`] = item.departments == -1 ? 0 : item.departments;
                  gridData[5][`column_filter_${filterTableCount + 1}_${elementId}`] = item.wards == -1 ? 0 : item.wards;
                  gridData[6][`column_filter_${filterTableCount + 1}_${elementId}`] = item.countries == -1 ? 0 : item.countries;
                  gridData[7][`column_filter_${filterTableCount + 1}_${elementId}`] = item.institutions == -1 ? 0 : item.institutions;
                }
              });
            } else {

              fields.push(
                { 'field': `column_filter_${filterTableCount + 1}`, 'title': '', 'group': `${this.data.filter && this.data.filter[filterTableCount] ? this.data.filter[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}` },
              );

              res2.forEach((item, i) => {
                if (gridData.length == 0) {
                  var complianceRate = { name: this.layoutService.translateText('DASHBOARD.TOTAL_PERCENT_COMPLIANCE') }
                  var opportunities = { name: this.layoutService.translateText('DASHBOARD.OPPORTUNITIES') }
                  var handrubs = { name: this.layoutService.translateText('DASHBOARD.NUMBER_HANDRUB') }
                  var handwashes = { name: this.layoutService.translateText('DASHBOARD.NUMBER_HANDWASHING') }
                  var departments = { name: this.layoutService.translateText('DASHBOARD.NUMBER_DEPARTMENTS') }
                  var wards = { name: this.layoutService.translateText('DASHBOARD.NUMBER_WARDS') }
                  var countries = { name: this.layoutService.translateText('DASHBOARD.NUMBER_COUNTRIES') }
                  var institutions = { name: this.layoutService.translateText('DASHBOARD.NUMBER_INSTITUTIONS') }

                  complianceRate[`column_filter_${filterTableCount + 1}`] = item.compliance == -1 ? "N/A" : item.compliance;
                  opportunities[`column_filter_${filterTableCount + 1}`] = item.opportunities == -1 ? 0 : item.opportunities;
                  handrubs[`column_filter_${filterTableCount + 1}`] = item.handRubs == -1 ? 0 : item.handRubs;
                  handwashes[`column_filter_${filterTableCount + 1}`] = item.handWashes == -1 ? "N/A" : item.handWashes;
                  departments[`column_filter_${filterTableCount + 1}`] = item.departments == -1 ? 0 : item.departments;
                  wards[`column_filter_${filterTableCount + 1}`] = item.wards == -1 ? 0 : item.wards;
                  countries[`column_filter_${filterTableCount + 1}`] = item.countries == -1 ? 0 : item.countries;
                  institutions[`column_filter_${filterTableCount + 1}`] = item.institutions == -1 ? 0 : item.institutions;

                  gridData.push(complianceRate, opportunities, handrubs, handwashes, departments, wards, countries, institutions);
                } else {
                  gridData[0][`column_filter_${filterTableCount + 1}`] = item.compliance == -1 ? "N/A" : item.compliance;
                  gridData[1][`column_filter_${filterTableCount + 1}`] = item.opportunities == -1 ? 0 : item.opportunities;
                  gridData[2][`column_filter_${filterTableCount + 1}`] = item.handRubs == -1 ? 0 : item.handRubs;
                  gridData[3][`column_filter_${filterTableCount + 1}`] = item.handWashes == -1 ? "N/A" : item.handWashes;
                  gridData[4][`column_filter_${filterTableCount + 1}`] = item.departments == -1 ? 0 : item.departments;
                  gridData[5][`column_filter_${filterTableCount + 1}`] = item.wards == -1 ? 0 : item.wards;
                  gridData[6][`column_filter_${filterTableCount + 1}`] = item.countries == -1 ? 0 : item.countries;
                  gridData[7][`column_filter_${filterTableCount + 1}`] = item.institutions == -1 ? 0 : item.institutions;
                }
              });
            }

          });
        } else {
          overallComplianceArray.overallComplianceList.forEach((element) => {
            let res2 = element.list;
            let multiName = '';
            let elementId = '';
            if (overallComplianceArray.filterType && overallComplianceArray.filterType != 'single') {
              multiName = element.name;
              elementId = element.id;
              if (element.list.length == 0 && element.noData == true) {
                multiName = 'EVALUATION.NO_DATA'
                elementId = 'nodata';
              }
              benchmarkFields.push(
                { 'field': `column_benchmark_${benchmarkTableCount + 1}_${elementId}`, 'title': multiName, 'group': `${this.data.filter && this.data.filter[benchmarkTableCount] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.filter[benchmarkTableCount].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkTableCount + 1)}` },
              );

              res2.forEach((item, i) => {
                if (gridData.length == 0) {
                  var complianceRate = { name: this.layoutService.translateText('DASHBOARD.TOTAL_PERCENT_COMPLIANCE') }
                  var opportunities = { name: this.layoutService.translateText('DASHBOARD.OPPORTUNITIES') }
                  var handrubs = { name: this.layoutService.translateText('DASHBOARD.NUMBER_HANDRUB') }
                  var handwashes = { name: this.layoutService.translateText('DASHBOARD.NUMBER_HANDWASHING') }
                  var departments = { name: this.layoutService.translateText('DASHBOARD.NUMBER_DEPARTMENTS') }
                  var wards = { name: this.layoutService.translateText('DASHBOARD.NUMBER_WARDS') }
                  var countries = { name: this.layoutService.translateText('DASHBOARD.NUMBER_COUNTRIES') }
                  var institutions = { name: this.layoutService.translateText('DASHBOARD.NUMBER_INSTITUTIONS') }

                  complianceRate[`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.compliance == -1 ? "N/A" : item.compliance;
                  opportunities[`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.opportunities == -1 ? 0 : item.opportunities;
                  handrubs[`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.handRubs == -1 ? 0 : item.handRubs;
                  handwashes[`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.handWashes == -1 ? "N/A" : item.handWashes;
                  departments[`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.departments == -1 ? 0 : item.departments;
                  wards[`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.wards == -1 ? 0 : item.wards;
                  countries[`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.countries == -1 ? 0 : item.countries;
                  institutions[`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.institutions == -1 ? 0 : item.institutions;

                  gridData.push(complianceRate, opportunities, handrubs, handwashes, departments, wards, countries, institutions);
                } else {
                  gridData[0][`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.compliance == -1 ? "N/A" : item.compliance;
                  gridData[1][`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.opportunities == -1 ? 0 : item.opportunities;
                  gridData[2][`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.handRubs == -1 ? 0 : item.handRubs;
                  gridData[3][`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.handWashes == -1 ? "N/A" : item.handWashes;
                  gridData[4][`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.departments == -1 ? 0 : item.departments;
                  gridData[5][`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.wards == -1 ? 0 : item.wards;
                  gridData[6][`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.countries == -1 ? 0 : item.countries;
                  gridData[7][`column_benchmark_${benchmarkTableCount + 1}_${elementId}`] = item.institutions == -1 ? 0 : item.institutions;
                }
              });
            } else {

              benchmarkFields.push(
                { 'field': `column_benchmark_${benchmarkTableCount + 1}`, 'title': '', 'group': `${this.data.filter && this.data.filter[benchmarkTableCount] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.filter[benchmarkTableCount].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkTableCount + 1)}` },
              );

              res2.forEach((item, i) => {
                if (gridData.length == 0) {
                  var complianceRate = { name: this.layoutService.translateText('DASHBOARD.TOTAL_PERCENT_COMPLIANCE') }
                  var opportunities = { name: this.layoutService.translateText('DASHBOARD.OPPORTUNITIES') }
                  var handrubs = { name: this.layoutService.translateText('DASHBOARD.NUMBER_HANDRUB') }
                  var handwashes = { name: this.layoutService.translateText('DASHBOARD.NUMBER_HANDWASHING') }
                  var departments = { name: this.layoutService.translateText('DASHBOARD.NUMBER_DEPARTMENTS') }
                  var wards = { name: this.layoutService.translateText('DASHBOARD.NUMBER_WARDS') }
                  var countries = { name: this.layoutService.translateText('DASHBOARD.NUMBER_COUNTRIES') }
                  var institutions = { name: this.layoutService.translateText('DASHBOARD.NUMBER_INSTITUTIONS') }

                  complianceRate[`column_benchmark_${benchmarkTableCount + 1}`] = item.compliance == -1 ? "N/A" : item.compliance;
                  opportunities[`column_benchmark_${benchmarkTableCount + 1}`] = item.opportunities == -1 ? 0 : item.opportunities;
                  handrubs[`column_benchmark_${benchmarkTableCount + 1}`] = item.handRubs == -1 ? 0 : item.handRubs;
                  handwashes[`column_benchmark_${benchmarkTableCount + 1}`] = item.handWashes == -1 ? "N/A" : item.handWashes;
                  departments[`column_benchmark_${benchmarkTableCount + 1}`] = item.departments == -1 ? 0 : item.departments;
                  wards[`column_benchmark_${benchmarkTableCount + 1}`] = item.wards == -1 ? 0 : item.wards;
                  countries[`column_benchmark_${benchmarkTableCount + 1}`] = item.countries == -1 ? 0 : item.countries;
                  institutions[`column_benchmark_${benchmarkTableCount + 1}`] = item.institutions == -1 ? 0 : item.institutions;

                  gridData.push(complianceRate, opportunities, handrubs, handwashes, departments, wards, countries, institutions);
                } else {
                  gridData[0][`column_benchmark_${benchmarkTableCount + 1}`] = item.compliance == -1 ? "N/A" : item.compliance;
                  gridData[1][`column_benchmark_${benchmarkTableCount + 1}`] = item.opportunities == -1 ? 0 : item.opportunities;
                  gridData[2][`column_benchmark_${benchmarkTableCount + 1}`] = item.handRubs == -1 ? 0 : item.handRubs;
                  gridData[3][`column_benchmark_${benchmarkTableCount + 1}`] = item.handWashes == -1 ? "N/A" : item.handWashes;
                  gridData[4][`column_benchmark_${benchmarkTableCount + 1}`] = item.departments == -1 ? 0 : item.departments;
                  gridData[5][`column_benchmark_${benchmarkTableCount + 1}`] = item.wards == -1 ? 0 : item.wards;
                  gridData[6][`column_benchmark_${benchmarkTableCount + 1}`] = item.countries == -1 ? 0 : item.countries;
                  gridData[7][`column_benchmark_${benchmarkTableCount + 1}`] = item.institutions == -1 ? 0 : item.institutions;
                }
              });
            }

          });
        }

        if (overallComplianceArray.isBenchmark) {
          benchmarkTableCount += 1;
        } else {
          filterTableCount += 1;
        }

        this.results[chartIndex].gridData = gridData;
        this.results[chartIndex].fields = fields;
        this.results[chartIndex].benchmarkFields = benchmarkFields;
        this.results[chartIndex].resultChart = chart;

        if (index == res.length - 1) {
          this.compliance.resultsLoader.next(cloneDeep(this.results));
          if (this.exportTag) {
            this.exportTag.results = Object.assign([], this.results);
          }
        }

        setTimeout(() => {
          let complianceChart = this.compliance.charts.get(chartIndex);
          if (complianceChart) {
            complianceChart.chartDatamani();
          }
          this.compliance.setComplianceFields(this.results[chartIndex], 6, 2);
          this.compliance.setFilters(this.filters.toArray());
        }, 500);
      });

      this.changeLangProcessPage();
      this.evaluationLoaded = true;
      setTimeout(() => { this.initializeFilters(); }, 1000);
    }, 1000);
    
  }

  initializeFilters() {
    this.selectedSeries = [];
    this.filters.forEach((filter, index) => {
      filter.visible = true;
    });

    this.evaluationService.getObserveEvaluationSeries(this.userID, "overallcompliance").subscribe((seriesData: any) => {
      if (!seriesData || seriesData.selectedSeries == null) {
        this.layoutService.showLoader = false;
        return;
      }

      this.selectedSeries = JSON.parse(seriesData.selectedSeries);
      if (this.selectedSeries.length == 0) {
        this.layoutService.showLoader = false;
        return;
      }

      let chartSeries = JSON.parse(seriesData.selectedSeries);


      setTimeout(() => {
        chartSeries.forEach(serie => {
          if(typeof serie === 'number'){
              this.charts.forEach((chart) => {
                this.compliance.toggleVisibility(chart.chartId, {index: serie });
                chart.internalToggleSerie({ index: serie });
              });
          }else{
            let chart = this.charts.find(c => c.chartId === serie.chartId);
            if(!chart) return;
            serie.series.forEach((serie) => {
              chart.internalToggleSerie({ index: serie });
              this.compliance.toggleVisibility(chart.chartId, {index: serie });
            });
            this.filters.forEach((filter, index) => {
              if (index != serie.series) return;
              if (filter.visible == undefined) filter.visible = true;
              filter.visible = !filter.visible;
            });
          }
        });
      }, 1500);
    }, (error) => {
      this.layoutService.showLoader = false;
    }, () => {
      this.layoutService.showLoader = false;
    });
  }

  filterBenchmarkDataIfWardIsSelected(res): any {
    if (this.shouldHideBenchmarkData())
      return res.filter(item => !item.isBenchmark);
    else
      return res;
  }

  shouldHideBenchmarkData() {
    return this.anyWardIsSelected();
  }

  shouldHideBenchmarkDataByResponse(complianceList) {
    // If there is any response isBenchmark: true, then we should show benchmark data
    return complianceList.some(item => item.isBenchmark);
  }

  anyWardIsSelected() {
    for (let filterComponent of this.filters.toArray()) {
      if (filterComponent.isWardSelected()) {
        return true;
      }
    }
    return false;
  }

  adjustResponseForEnvironment(res) {
    if (!this.isDesktop && res.length >= 2) {
      let spliceCount = 0;
      let idx = 1;
      res.forEach((processComplianceArray: any, index) => {
        if (index === 1) {
          if (processComplianceArray.isBenchmark === false) {
            spliceCount++;
          } else {
            idx = 2;
          }
        } else if (index === 2 || index === 3) {
          spliceCount++;
        }
      });
      return res.splice(idx, spliceCount);
    }
    return res;
  }

  changeLangProcessPage() {
    this.results.forEach((result, gridIndex) => {
      result.gridData.forEach((value, index) => {
        if (value.title)
          this.results[gridIndex].gridData[index].title = this.layoutService.translateText(value.title);
        this.compliance.results[gridIndex].gridData[index].title = this.layoutService.translateText(value.title);
      });
    });
  }

  onFilterRemoved(filterIndexToRemove: number) {
    const index = this.filterIndices.indexOf(filterIndexToRemove);

    if (index !== -1) {
      this.filterIndices.splice(index, 1);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    if (this.userHasFilter) {
      this.layoutService.showLoader = true;
      setTimeout(() => { this.evaluate(true); }, 1000);
    }
  }

  exportAs() {
    this.clickImageBtn = true;
  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  downloadKendoPDF() {
    this.clickPdfBtn = true;
  }

  resetFilters() {
    this.filterDetails = [this.userFilters[0]];
    this.filterIndices = [0];
    this.filters.toArray()[0].resetFilter(true);
    this.layoutService.showLoader = true;
    
    var seriesData = {
      userId: this.userID,
      complianceType: "overallcompliance",
      selectedSeries: null
    };

    this.evaluationService.updateObserveEvaluationSeries(seriesData).subscribe(() => {
      setTimeout(() => { this.evaluate(true); }, 1500);
     }, () => { }, () => { });

  }

  originalFields: any[] = null;
  originalBenchmarkFields: any[] = null;
  selectedSeries: any[] = [];

  onSeriesClick(serie: any, resultIndex: number) {
    let chart = this.charts.find( c => c.chartId == serie.chartId);
    chart.series.get(serie.index).options.visible = serie.visible;

    this.filters.forEach((filter, index) => {
      if (index != serie.index) return;
      if (filter.visible == undefined) filter.visible = true;
      filter.visible = !filter.visible;
    });

    this.compliance.toggleVisibility(serie.chartId,serie);

    let visibilitySeries = [];

    this.charts.forEach((chart) => {
      let c = {
        chartId: chart.chartId,
        series: chart.series.map((s, index) => ({ series: s, index }))
                            .filter(s => s.series.options.visible === false)
                            .map(s => s.index)
      }
      visibilitySeries.push(c);
    })

    var seriesData = {
      userId: this.userID,
      complianceType: "overallcompliance",
      selectedSeries: JSON.stringify(visibilitySeries)
    };

    this.evaluationService.updateObserveEvaluationSeries(seriesData).subscribe(() => { }, () => { }, () => { });
  }

  onFilterSaved() {
    // Buscar nombres duplicados y renombrar los duplicados
    const renamedFilters: string[] = [];
    var filters = this.filters.toArray();
    // Recorre desde el último hasta el primero
    for (let i = filters.length - 1; i >= 0; i--) {
      const currentName = filters[i].filterName?.trim() || '';
      for (let j = 0; j < filters.length; j++) {
        if (i !== j && currentName && currentName === (filters[j].filterName?.trim() || '')) {
          // Si hay coincidencia, renombra el actual
          const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (i + 1);
          filters[i].filterName = translatedFilterName;
          filters[i].setFilterName = translatedFilterName;          
          renamedFilters.push(translatedFilterName);
          break;
        }
      }
    }

  if (renamedFilters.length > 0) {
        const f = renamedFilters[renamedFilters.length - 1];
        const msg = `${this.layoutService.translateText('EVALUATION.FILTER_DUPLICATED_NAME')} '${f}'.`;
        this.layoutService.showWarning(msg);
    }
    this.evaluate(true);
  }

  onRefreshClick(noDataFound: boolean) {
    if (noDataFound) {
      return;
    }

    this.evaluate(true);
  }

  saveSummarisedReport() {
    if (this.userHasFilter) {
      this.evaluate(false);
    }
  }

  trackLoop(index: number, item: any) {
    return item;
  }
}
